module.exports = __webpack_public_path__ + "img/foto1.2b18fcfb.jpg";